import React from "react";
import EventList from "./EventList";
function FindEvents() {
    return (
        <EventList />
    )
}
export default FindEvents;